import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import {
    TransformResponse
} from './transform';

import {
    SETSELECTED,
    SETSELECTED_CERNER,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET,
    SET_CERNER as PATIENTCERNER
} from 'one-state-subject/src/types';

import {
    setAction as setAppointmentsTable,
    setSelectedPatient,
    reinitAction,
    reInitOnPatientChangeAction
} from 'one-state-appointments';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format,substract_daysoncurrentdate,add_daysoncurrentdate} from 'one-util-date';
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';
export const enum Types {
    SETAPPOINTMENTS = 'set-appointments/set-cerner',
    SETAPPOINTMENTSSUCCESS = 'set-appointments-success-cerner',
    CANCELAPPT = 'one-state-appointments/cancel-appt-cerner',
    SETCANCELAPPT='one-state-appointments/push-cancel-appt',
    STORE_DISPOSITION_CODE = "store-disposition-code",
    CONFIRMAPPT = 'one-state-appointments/confirm-appt-cerner',
    SETCONFIRMAPPT='one-state-appointments/push-confirm-appt',
    UPDATEAPPT = 'one-state-appointments/update-appt',
    SETUPDATEAPPT='one-state-appointments/push-update-appt-cerner',
    CANCELAPPT_CERNER='one-state-appointments/cancel-appt-cerner'
}

const setAppointments = (payload: any) => ({ type: Types.SETAPPOINTMENTS, payload });
const pushtoApptsTable = (payload: any) => setAppointmentsTable(payload);
const pushtoCancelAppt = (payload:any) => ({type:Types.SETCANCELAPPT, payload});
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
const pushtoConfirmAppt = (payload: any) => ({type: Types.SETCONFIRMAPPT, payload});
const pushtoUpdateAppt = (payload:any) => ({type:Types.SETUPDATEAPPT, payload});

/**
 * This Fuction will fetch the data of upcoming appts
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchApptsCerner = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const {
            server,
            log,
            agentId,
            teamName,
            alertnotification,
            settings:
            {
                cernerendpoints: {
                    patientappointment,
                    apitoken
                },
                uisettings: {
                    dashboardapiconfig: {
                        patientappointment: patientappointmentApi
                    }
                },
                appointment_config: {
                    past_appointment_days,
                    future_appointment_days
                },
                compatible: { consolidated_api_invocation, contact_center_type, finesse_proxy_service },
                servers
            }
        } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE, Types.SETAPPOINTMENTSSUCCESS) : ofType(SETSELECTED_CERNER, Types.SETAPPOINTMENTSSUCCESS),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */
                let dataresponse: any = action.payload;
                log.debug("one-epics/cerner-epics", "fetch Appointments request", dataresponse);
                const getRequest = (datares: any) => {
                    if (datares?.id) {

                        let headers = new Headers();
                        // todo need to refractor to include authorization in interface
                        // headers.set('Authorization', 'Basic ' + apitoken?.token);
                        let startdate = substract_daysoncurrentdate(past_appointment_days, 'MM-DD-YYYY');
                        let enddate = add_daysoncurrentdate(future_appointment_days, 'MM-DD-YYYY');
                        const data = {
                            "CernerID": datares.id,
                            //"PatientID": "E5555",
                            //Mirth is taking care of Start and End Date
                            "StartDate": startdate,
                            "EndDate": enddate
                        }
                        let response;
                        if (finesse_proxy_service) {
                            response = InvokeFinesseProxy(patientappointment, data, apitoken, locations, log, 'POST', alertnotification);

                        } else {
                            response = server.post({
                                path: patientappointment,
                                data: data,
                                headers: headers
                            })
                                .then((responsefound: any) => responsefound)
                                .catch((responseresult: any) => {
                                    log.error(
                                        "ccw-gadget,upcomingappts-cerner",
                                        "fetch-Appt-cerner", {
                                        responseresult
                                    }
                                    );
                                    let errorbuild: ErrorObject = {
                                        source: "Appointments",
                                        type: "error",
                                        status: responseresult?.status,
                                        erroritems: responseresult?.errors,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    return errorbuild;
                                })
                            log.debug("one-epics/cerner-epics", "fetch Appointments response", response);
                        }
                        return from(response)
                    } else {
                        return from([]);
                    }

                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                if (!patientappointmentApi) return []
                return getRequest(dataresponse).
                    pipe(
                        flatMap((response: any) => {
                            const actions: any = [
                                setSelectedPatient(dataresponse.id)
                            ];
                            actions.push(setAppointments(response));
                            if (response && (response.status >= 400 || response.type == "error")) {
                                actions.push(addAction(response));
                                let disp: Disposition = { value: "1000" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse.id;
                                disp.meta03 = response.status;
                                disp.meta04 = response.erroritems?.[0]?.error_detail;
                                disp.meta05 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "183" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse.id;
                                disp.meta03 = '200';
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);

/**
 * This Function is used to fetch appointments
 * @param context contains settings json etc ..
 */
export const pushApptsTableCerner = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.SETAPPOINTMENTS),
            mergeMap((action: any) => {
                /**
                 * @param response contains the appointment response
                 */
                let response = action.payload;
                log.debug("one-epics/cerner-epics", "fetch Appointments request", response);
                if (response) {
                    const performAppTransformation = (datares: any) => {
                        let result = TransformResponse(datares, context, state$.value?.appointments?.selectedPatientId);
                        log.debug("one-epics/cener-epics", "fetch Appointments response", result);
                        return from([result]);
                    }
                    return performAppTransformation(response).
                        pipe(
                            map((transformresponse: any) => pushtoApptsTable(transformresponse))
                        )
                }
                else{
                    return from([]);
                }
            })

        )
    }
);

/**
 * This Function is used to cancel the Appointment
 * @param context haiving settings json etc..
 */
// export const pushCancelApptToCerner = (context: any) => (
//     (action$: any, state$: any) => {
//         const errorTime = format(new Date(), 'LT');
//         const errorDate = format(new Date(), 'LL');
//         const { server, log, alertnotification, agentId, teamName, settings: { servers, compatible, cernerendpoints: { cancelappointment, apitoken } } } = context;
//         const { contact_center_type, finesse_proxy_service } = compatible;
//         const { locations = [] } = servers;
//         return action$.pipe(
//             ofType(Types.CANCELAPPT_CERNER),
//             mergeMap((action: any) => {
//                 /**
//                  *  @param dataresponse conatains the payload data for cancel appt.
//                  */
//                 var dataresponse = action.payload;
//                 log.debug("one-epics/cerner-epics", "push Cancel Appointment request", dataresponse);
//                 const getRequest = (dataresponse1: any) => {
//                     if (dataresponse1) {
//                         let headers = new Headers();
//                         // todo need to refractor to include authorization in interface
//                         // headers.set('Authorization', 'Basic ' + apitoken?.token);
//                         // const data = {
//                         //     "PatientID": dataresponse1.PatientID,
//                         //     "Reason": dataresponse1.Reason,
//                         //     "Comment": dataresponse1.Comment
//                         // }
//                         //+ "?PatientID=" + dataresponse.PatientID + "&Reason=" + dataresponse.Reason + "&Comment=" + dataresponse.Comment + ""
//                         let response;
//                         if (finesse_proxy_service) {
//                             response = InvokeFinesseProxy(cancelappointment + "?AppointmentID=" + dataresponse1.appointmentID + "&VersionID=" + dataresponse1.versionID +"&Reason="+"oth-err"
//                                 , "", apitoken, locations, log, 'DELETE', alertnotification);

//                         } else {
//                             response = server.handle({
//                                 path: cancelappointment + "AppointmentID="+dataresponse1.appointmentID+"&VersionID="+dataresponse1.versionID +"&Reason="+"oth-err",
//                                 //data: data,
//                                 headers: headers
//                             }, 'delete')
//                                 .then((responsedata: any) => responsedata)
//                                 .catch((responseresultdata: any) => {
//                                     log.error(
//                                         "ccw-gadget,cancelappt-cerner",
//                                         "fetch-CancelAppt-to-cerner", {
//                                         responseresultdata
//                                     }
//                                     );
//                                     let errorbuild: ErrorObject = {
//                                         source: "CancelAppointment",
//                                         type: "error",
//                                         status: responseresultdata?.status,
//                                         erroritems: responseresultdata?.errors,
//                                         error_date: errorDate,
//                                         error_time: errorTime
//                                     };
//                                     return errorbuild;
//                                 })
//                             log.debug("one-epics/cerner-epics", "Cancel Appointments response", response);
//                         }
//                         return from(response)
//                     } else {
//                         return from([]);
//                     }

//                 }

//                 return getRequest(dataresponse)
//                     .pipe(
//                         flatMap((response: any) => {
//                             const actions: any = [
//                                 pushtoCancelAppt(response)
//                             ];
//                             if (response && (response.status >= 400 || response.type == "error")) {
//                                 actions.push(addAction(response));
//                             }
//                             //Disposition Framework
//                             if (Array.isArray(response) && response.length > 0) {
//                                 let val = response[0];
//                                 if (val && val.Success && val.Success === '1') {
//                                     let disp: Disposition = { value: "176" }
//                                     if (contact_center_type && contact_center_type === 'five9') {
//                                         let agentIdValue = sessionStorage.getItem("agentName");
//                                         disp.meta00 = agentIdValue;
//                                         disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
//                                     } else {
//                                         disp.meta00 = agentId;
//                                         disp.dial_list_uid = state$.value?.choosecaller?.callId;
//                                     }
//                                     disp.meta01 = teamName;
//                                     disp.meta02 = dataresponse.PatientID;
//                                     disp.meta03 = dataresponse.Reason;
//                                     disp.meta04 = 'client';
//                                     actions.push(pushToDisposition(disp));
//                                 } else {
//                                     let disp: Disposition = { value: "991" }
//                                     if (contact_center_type && contact_center_type === 'five9') {
//                                         let agentIdValue = sessionStorage.getItem("agentName");
//                                         disp.meta00 = agentIdValue;
//                                         disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
//                                     } else {
//                                         disp.meta00 = agentId;
//                                         disp.dial_list_uid = state$.value?.choosecaller?.callId;
//                                     }
//                                     disp.meta01 = teamName;
//                                     disp.meta02 = dataresponse.PatientID;
//                                     disp.meta03 = dataresponse.Reason;
//                                     disp.meta04 = 'client';
//                                     actions.push(pushToDisposition(disp));
//                                 }
//                             }
//                             //Disposition invocation in case of API down/failed
//                             if (response && (response.status >= 400 ||
//                                 (response.type === 'error' && response.source === 'CancelAppointment'))) {
//                                 let disp: Disposition = { value: "991" }
//                                 if (contact_center_type && contact_center_type === 'five9') {
//                                     let agentIdValue = sessionStorage.getItem("agentName");
//                                     disp.meta00 = agentIdValue;
//                                     disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
//                                 } else {
//                                     disp.meta00 = agentId;
//                                     disp.dial_list_uid = state$.value?.choosecaller?.callId;
//                                 }
//                                 disp.meta01 = teamName;
//                                 disp.meta02 = dataresponse.PatientID;
//                                 disp.meta03 = dataresponse.Reason;
//                                 disp.meta04 = 'client';
//                                 actions.push(pushToDisposition(disp));
//                             }
//                             return actions;
//                         })
//                     )
//             })
//         )
//     }
// );

/**
 * This Function is used to confirm the Appointment
 * @param context having settings json etc..
 */
// export const pushConfirmApptToCerner = (context: any) => (
//     (action$: any, state$: any) => {
//         const errorTime = format(new Date(), 'LT');
//         const errorDate = format(new Date(), 'LL');
//         const { server, log, alertnotification, agentId, teamName, settings: { compatible, servers, cernerendpoints: { confirmappointment, apitoken } } } = context;
//         const { contact_center_type, finesse_proxy_service } = compatible;
//         const { locations = [] } = servers;
//         return action$.pipe(
//             ofType(Types.CONFIRMAPPT),
//             mergeMap((action: any) => {
//                 /**
//                  *  @param dataresponse conatains the payload data for cancel appt.
//                  */
//                 let dataresponse = action.payload;
//                 log.debug("one-epics/cerner-epics", "push Confirm Appointment request", dataresponse);
//                 const getRequest = (dataresponse1: any) => {
//                     if (dataresponse1) {
//                         let headers = new Headers();
//                         // todo need to refractor to include authorization in interface
//                         headers.set('Authorization', 'Basic ' + apitoken?.token);
//                         let response;
//                         if (finesse_proxy_service) {
//                             response = InvokeFinesseProxy(confirmappointment + `?CommunicationType=${dataresponse1.CommunicationType}&ContactID=${dataresponse1.ContactID}&ContactIDType=${dataresponse1.ContactIDType}&NotificationResponse=Confirmed&PatientID=${dataresponse1.PatientID}&PatientIDType=${dataresponse1.PatientIDType}&UserID=${dataresponse1.UserID}&UserIDType=${dataresponse1.UserIDType}`, "", apitoken, locations, log, 'PUT', alertnotification);

//                         } else {
//                          response = server.put({
//                             path: `${confirmappointment}?CommunicationType=${dataresponse1.CommunicationType}&ContactID=${dataresponse1.ContactID}&ContactIDType=${dataresponse1.ContactIDType}&NotificationResponse=Confirmed&PatientID=${dataresponse1.PatientID}&PatientIDType=${dataresponse1.PatientIDType}&UserID=${dataresponse1.UserID}&UserIDType=${dataresponse1.UserIDType}`,
//                             headers
//                         })
//                             .then((responsedata: any) => responsedata)
//                             .catch((responseresultdata: any) => {
//                                 log.error(
//                                     "ccw-gadget,confirmappt-cerner",
//                                     "fetch-ConfirmAppt-to-cerner", {
//                                     responseresultdata
//                                 }
//                                 );
//                                 let errorbuild: ErrorObject = {
//                                     source: "ConfirmAppointment",
//                                     type: "error",
//                                     status: responseresultdata?.status,
//                                     erroritems: responseresultdata?.errors,
//                                     error_date: errorDate,
//                                     error_time: errorTime
//                                 };
//                                 return errorbuild;
//                             })
//                                 .then((responsedata: any) => responsedata)
//                                 .catch((responseresultdata: any) => {
//                                     log.error(
//                                         "ccw-gadget,confirmappt-cerner",
//                                         "fetch-ConfirmAppt-to-cerner", {
//                                         responseresultdata
//                                     }
//                                     );
//                                     let errorbuild: ErrorObject = {
//                                         source: "ConfirmAppointment",
//                                         type: "error",
//                                         status: responseresultdata?.status,
//                                         erroritems: responseresultdata?.errors,
//                                         error_date: errorDate,
//                                         error_time: errorTime
//                                     };
//                                     return errorbuild;
//                                 })
//                             log.debug("one-epics/cerner-epics", "Confirm Appointments response", response);
//                         }
//                         return from(response)
//                     } else {
//                         return from([]);
//                     }

//                 }

//                 return getRequest(dataresponse)
//                     .pipe(
//                         flatMap((response: any) => {
//                             const actions: any = [
//                                 pushtoConfirmAppt(response)
//                             ];
//                             if (response && (response.status >= 400 || response.type == "error")) {
//                                 actions.push(addAction(response));
//                             }

//                             //Disposition Framework
//                             const disp: Disposition = { value: "1010" };
//                             if (contact_center_type && contact_center_type === 'five9') {
//                                 let agentIdValue = sessionStorage.getItem("agentName");
//                                 disp.meta00 = agentIdValue;
//                                 disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
//                             } else {
//                                 disp.meta00 = agentId;
//                                 disp.dial_list_uid = state$.value?.choosecaller?.callId;
//                             }
//                             disp.meta01 = teamName;
//                             disp.meta02 = dataresponse.PatientID;
//                             disp.meta03 = dataresponse.deptID;
//                             disp.meta04 = dataresponse.visitTypeID;
//                             disp.meta05 = dataresponse.providerID;
//                             disp.meta06 = 'client';

//                             if (response && (response.status >= 400 ||
//                                 (response.type === 'error' && response.source === 'ConfirmAppointment'))) {
//                                 disp.value = "2022";
//                             }
//                             actions.push(pushToDisposition(disp));

//                             return actions;
//                         })
//                     )
//             })
//         )
//     }
// );

/**
 * Listen for component clear and intiate state clear for Active Problems
 * @param context  contains logger which is used for logging
 */
export const clearAppointmentsCerner = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, appointments-cerner",
            "clear-appointments-cerner", {
        });
        return action$.pipe(
            ofType(PATIENTSET,PATIENTRESET,PATIENTCERNER),
            map(action => reinitAction())
        )

    }
);

/**
 * Listen for component clear when patient is changed in the subject card
 * @param context  contains logger which is used for logging
 */
export const clearAppointmentsonPatientChangeCerner = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, appointments-cerner",
            "clear-appointments-cerner", {
        });
        return action$.pipe(
            ofType(SETSELECTED, SETPATIENTSELECTED),
            map(action => reInitOnPatientChangeAction())
        )

    }
);
/**
 * This Function is used to update the Appointment
 * @param context haiving settings json etc..
 */
//  export const pushUpdateApptToCerner = (context: any) => (
//     (action$: any, state$: any) => {
//         const errorTime = format(new Date(),'LT');
//         const errorDate = format(new Date(),'LL');
//         const { server, log, agentId,teamName, settings: { compatible,cernerendpoints: { updateappointment, apitoken } } } = context;
//         const { contact_center_type } = compatible;
//         return action$.pipe(
//             ofType(Types.UPDATEAPPT),
//             mergeMap((action: any) => {
//                 /**
//                  *  @param dataresponse conatains the payload data for update appt.
//                  */
//                 var dataresponse = action.payload;
//                 log.debug("one-epics/cerner-epics", "push Update Appointment request", dataresponse);

//                 const getRequest = (dataresponse1: any) => {
//                     if (dataresponse1) {
//                         let headers = new Headers();
//                         // todo need to refractor to include authorization in interface
//                         headers.set('Authorization', 'Basic ' + apitoken?.token);
//                         // const data = {
//                         //     "PatientID": dataresponse1.PatientID,
//                         //     "Reason": dataresponse1.Reason,
//                         //     "Comment": dataresponse1.Comment
//                         // }
//                         //+ "?PatientID=" + dataresponse.PatientID + "&Reason=" + dataresponse.Reason + "&Comment=" + dataresponse.Comment + ""
//                         const response = server.put({
//                             path: updateappointment + "?PatientID=" + dataresponse1.PatientID +"&PatientIDType=" + dataresponse1.PatientIDType+ "&UserID="+dataresponse1.UserID+"&UserIDType="+dataresponse1.UserIDType + "&ContactID=" + dataresponse1.ContactID + "&ContactIDType=" + dataresponse1.ContactIDType +"",
//                             data: {"Notes":dataresponse1.notes},
//                             headers: headers
//                         }, 'delete')
//                             .then((responsedata: any) => responsedata)
//                             .catch((responseresultdata: any) => {
//                                 log.error(
//                                     "ccw-gadget,updateappt-cerner",
//                                     "fetch-UpdateAppt-to-cerner", {
//                                     responseresultdata
//                                 }
//                                 );
//                                 let errorbuild: ErrorObject = {
//                                     source: "UpdateAppointment",
//                                     type: "error",
//                                     status: responseresultdata?.status,
//                                     erroritems: responseresultdata?.errors,
//                                     error_date: errorDate,
//                                     error_time: errorTime
//                                 };
//                                 return errorbuild;
//                             })
//                         log.debug("one-epics/cerner-epics", "Update Appointments response", response);
//                         return from(response)
//                     } else {
//                         return from([]);
//                     }

//                 }

//                 return getRequest(dataresponse)
//                     .pipe(
//                         flatMap((response: any) => {
//                             const actions: any = [
//                                 pushtoUpdateAppt(response)
//                             ];
//                             if (response && (response.status >= 400 || response.type == "error")) {
//                                 actions.push(addAction(response));
//                             }
//                             //Disposition Framework
//                             if (Array.isArray(response) && response.length > 0) {
//                                 let val = response[0];
//                                 if (val && val.Success && val.Success === '1') {
//                                     let disp: Disposition = { value: "176" }
//                                     if (contact_center_type && contact_center_type === 'five9') {
//                                         let agentIdValue = sessionStorage.getItem("agentName");
//                                         disp.meta00 = agentIdValue;
//                                         disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
//                                     } else {
//                                         disp.meta00 = agentId;
//                                         disp.dial_list_uid = state$.value?.choosecaller?.callId;
//                                     }
//                                     disp.meta01 = teamName;
//                                     disp.meta02 = dataresponse.PatientID;
//                                     disp.meta03 = dataresponse.Reason;
//                                     disp.meta04 = 'client';
//                                     actions.push(pushToDisposition(disp));
//                                 } else {
//                                     let disp: Disposition = { value: "991" }
//                                     if (contact_center_type && contact_center_type === 'five9') {
//                                         let agentIdValue = sessionStorage.getItem("agentName");
//                                         disp.meta00 = agentIdValue;
//                                         disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
//                                     } else {
//                                         disp.meta00 = agentId;
//                                         disp.dial_list_uid = state$.value?.choosecaller?.callId;
//                                     }
//                                     disp.meta01 = teamName;
//                                     disp.meta02 = dataresponse.PatientID;
//                                     disp.meta03 = dataresponse.Reason;
//                                     disp.meta04 = 'client';
//                                     actions.push(pushToDisposition(disp));
//                                 }
//                             }
//                             //Disposition invocation in case of API down/failed
//                             if (response && (response.status >= 400 || 
//                                 (response.type === 'error' && response.source === 'UpdateAppointment'))) {
//                                     let disp: Disposition = { value: "991" }
//                                     if (contact_center_type && contact_center_type === 'five9') {
//                                         let agentIdValue = sessionStorage.getItem("agentName");
//                                         disp.meta00 = agentIdValue;
//                                         disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
//                                     } else {
//                                         disp.meta00 = agentId;
//                                         disp.dial_list_uid = state$.value?.choosecaller?.callId;
//                                     }
//                                     disp.meta01 = teamName;
//                                     disp.meta02 = dataresponse.PatientID;
//                                     disp.meta03 = dataresponse.Reason;
//                                     disp.meta04 = 'client';
//                                     actions.push(pushToDisposition(disp));
//                             }
//                             return actions;
//                         })
//                     )
//             })
//         )
//     }
// );